(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-media"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-gallery].sb-featured-media');
  if (!root) return;

  var items = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-item]'));
  var lightbox = document.querySelector('[data-lightbox]');
  if (lightbox && window.SBGalleryLightbox) {
    window.SBGalleryLightbox.init({
      root: root,
      lightbox: lightbox,
      getVisibleItems: function () { return items; }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-archive"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-gallery]');
  if (!root) return;

  var items = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-item]'));
  var countEl = root.querySelector('[data-gallery-count]');
  var emptyEl = root.querySelector('[data-gallery-empty]');
  var typePills = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-type]'));

  // Event names live on the rendered tiles (theme blocks don't expose sibling
  // settings to the section), so the Events sub-nav is built here instead of in Liquid.
  var eventsSublist = root.querySelector('[data-gallery-events-sublist]');
  if (eventsSublist) {
    var seenEvents = {};
    items.forEach(function (item) {
      var eventName = item.getAttribute('data-event');
      if (item.getAttribute('data-category') !== 'events' || !eventName || seenEvents[eventName]) return;
      seenEvents[eventName] = true;
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sb-gallery__nav-link sb-gallery__nav-link--sub';
      btn.setAttribute('data-gallery-filter', '');
      btn.setAttribute('data-filter-category', 'events');
      btn.setAttribute('data-filter-event', eventName);
      btn.textContent = eventName;
      li.appendChild(btn);
      eventsSublist.appendChild(li);
    });
  }

  var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-filter]'));
  var eventsToggleBtn = root.querySelector('[data-gallery-filter][data-filter-category="events"]:not([data-filter-event])');

  var state = { category: 'all', event: null, type: 'all' };
  var visibleItems = [];

  function applyFilters() {
    visibleItems = [];
    items.forEach(function (item) {
      var matchesCategory = state.category === 'all' || item.getAttribute('data-category') === state.category;
      var matchesEvent = !state.event || item.getAttribute('data-event') === state.event;
      var matchesType = state.type === 'all' || item.getAttribute('data-type') === state.type;
      var show = matchesCategory && matchesEvent && matchesType;
      item.hidden = !show;
      if (show) visibleItems.push(item);
    });
    if (countEl) {
      countEl.textContent = visibleItems.length + (visibleItems.length === 1 ? ' item' : ' items');
    }
    if (emptyEl) emptyEl.hidden = visibleItems.length !== 0;
  }

  navLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      navLinks.forEach(function (l) { l.classList.remove('is-active'); });
      link.classList.add('is-active');
      state.category = link.getAttribute('data-filter-category');
      state.event = link.getAttribute('data-filter-event') || null;
      applyFilters();

      // Clicking a different top-level category collapses the Events dropdown.
      if (eventsSublist && eventsToggleBtn && link !== eventsToggleBtn && !link.hasAttribute('data-filter-event')) {
        eventsSublist.hidden = true;
        eventsToggleBtn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  if (eventsToggleBtn && eventsSublist) {
    eventsToggleBtn.addEventListener('click', function () {
      var willOpen = eventsSublist.hidden;
      eventsSublist.hidden = !willOpen;
      eventsToggleBtn.setAttribute('aria-expanded', String(willOpen));
    });
  }

  typePills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      typePills.forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      state.type = pill.getAttribute('data-gallery-type');
      applyFilters();
    });
  });

  applyFilters();

  var lightbox = document.querySelector('[data-lightbox]');
  if (lightbox && window.SBGalleryLightbox) {
    window.SBGalleryLightbox.init({
      root: root,
      lightbox: lightbox,
      getVisibleItems: function () { return visibleItems; }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
